import { defineMessages } from "react-intl";

import createRoute1 from "@app/assets/guides/gettingStarted/create-route-1.jpg";
import createRoute2 from "@app/assets/guides/gettingStarted/create-route-2.jpg";
import createRoute3 from "@app/assets/guides/gettingStarted/create-route-3.jpg";
import editRoute1 from "@app/assets/guides/gettingStarted/edit-route-1.jpg";
import editRoute2 from "@app/assets/guides/gettingStarted/edit-route-2.jpg";
import editRoute3 from "@app/assets/guides/gettingStarted/edit-route-3.jpg";
import filters1 from "@app/assets/guides/gettingStarted/filters-1.jpg";
import filters2 from "@app/assets/guides/gettingStarted/filters-2.jpg";
import leadFinder1 from "@app/assets/guides/gettingStarted/lead-finder-1.jpg";
import leadFinder2 from "@app/assets/guides/gettingStarted/lead-finder-2.jpg";
import planner from "@app/assets/guides/gettingStarted/planner.jpg";
import qrCodes from "@app/assets/guides/gettingStarted/qr2.png";
import records from "@app/assets/guides/gettingStarted/records.jpg";
import WizardDescriptor from "@app/component/flows/types/WizardDescriptor";

const messages = defineMessages({
  step00: {
    id: "guides.gettingStartedForMobile.wizard.step0",
    defaultMessage: "Download the app & sign in to your account",
  },
  step00Description: {
    id: "guides.gettingStartedForMobile.wizard.step0.description",
    defaultMessage:
      "If you haven’t done so already, scan the QR code to download the app on your mobile device. Once you sign in to your account from mobile, click ‘Next’.",
  },
  step01: {
    id: "guides.gettingStartedForMobile.wizard.step1",
    defaultMessage: "Map View - Opening Records",
  },
  step01Description: {
    id: "guides.gettingStartedForMobile.wizard.step1.description",
    defaultMessage:
      "Click on a map pin to open that record’s details. If that address has multiple records at it, a list of records will appear.",
  },
  step02: {
    id: "guides.gettingStartedForMobile.wizard.step2",
    defaultMessage: "Map View - Filtering",
  },
  step02Description: {
    id: "guides.gettingStartedForMobile.wizard.step2.description",
    defaultMessage: "To filter records visible on a map, click here.",
  },
  step03: {
    id: "guides.gettingStartedForMobile.wizard.step3",
    defaultMessage: "Map View - Filtering",
  },
  step03Description: {
    id: "guides.gettingStartedForMobile.wizard.step3.description",
    defaultMessage:
      "Feel free to pick a 'saved filter' or click on the plus icon to create a new one.",
  },
  step04: {
    id: "guides.gettingStartedForMobile.wizard.step4",
    defaultMessage: "Map View - Lead Finder",
  },
  step04Description: {
    id: "guides.gettingStartedForMobile.wizard.step4.description",
    defaultMessage: "To find new leads, click the wrench icon to open the Lead Finder.",
  },
  step05: {
    id: "guides.gettingStartedForMobile.wizard.step5",
    defaultMessage: "Map View - Lead Finder",
  },
  step05Description: {
    id: "guides.gettingStartedForMobile.wizard.step5.description",
    defaultMessage:
      "Specify your keyword, search radius and the location to search from, then click the Search button.",
  },
  step06: {
    id: "guides.gettingStartedForMobile.wizard.step6",
    defaultMessage: "Routing - Creation",
  },
  step06Description: {
    id: "guides.gettingStartedForMobile.wizard.step6.description",
    defaultMessage: "To create a new route, go to the Routes page and click on the plus icon.",
  },
  step07: {
    id: "guides.gettingStartedForMobile.wizard.step7",
    defaultMessage: "Routing - Creation",
  },
  step07Description: {
    id: "guides.gettingStartedForMobile.wizard.step7.description",
    defaultMessage: "Then select the lasso tool within the blue wrench icon...",
  },
  step08: {
    id: "guides.gettingStartedForMobile.wizard.step8",
    defaultMessage: "Routing - Creation",
  },
  step08Description: {
    id: "guides.gettingStartedForMobile.wizard.step8.description",
    defaultMessage: "...and select all pins to include into a route.",
  },
  step09: {
    id: "guides.gettingStartedForMobile.wizard.step9",
    defaultMessage: "Routing - Editing",
  },
  step09Description: {
    id: "guides.gettingStartedForMobile.wizard.step9.description",
    defaultMessage: "To edit a route, first click it to open route details.",
  },
  step10: {
    id: "guides.gettingStartedForMobile.wizard.step10",
    defaultMessage: "Routing - Editing",
  },
  step10Description: {
    id: "guides.gettingStartedForMobile.wizard.step10.description",
    defaultMessage: "Then click the triple dots icon to open the menu.",
  },
  step11: {
    id: "guides.gettingStartedForMobile.wizard.step11",
    defaultMessage: "Routing - Editing",
  },
  step11Description: {
    id: "guides.gettingStartedForMobile.wizard.step11.description",
    defaultMessage:
      "And choose the desired action - whether you want to add or remove stops, change their order and more.",
  },
  step12: {
    id: "guides.gettingStartedForMobile.wizard.step12",
    defaultMessage: "Planner View",
  },
  step12Description: {
    id: "guides.gettingStartedForMobile.wizard.step12.description",
    defaultMessage: "To see activities in a calendar view, open the Activities page.",
  },
  title: {
    id: "guides.gettingStartedForMobile.wizard",
    defaultMessage: "Getting started",
  },
});

export const gettingStartedForMobileConfiguration: WizardDescriptor = {
  id: "mmc-getting-started-mobile",
  steps: [
    {
      id: "download-app",
      description: messages.step00Description,
      image: qrCodes,
      title: messages.step00,
    },
    {
      id: "map-opening-record",
      description: messages.step01Description,
      image: records,
      title: messages.step01,
    },
    {
      id: "map-filtering-1",
      description: messages.step02Description,
      image: filters1,
      title: messages.step02,
    },
    {
      id: "map-filtering-2",
      description: messages.step03Description,
      image: filters2,
      title: messages.step03,
    },
    {
      id: "map-lead-finder-1",
      description: messages.step04Description,
      image: leadFinder1,
      title: messages.step04,
    },
    {
      id: "map-lead-finder-2",
      description: messages.step05Description,
      image: leadFinder2,
      title: messages.step05,
    },
    {
      id: "routes-creation-1",
      description: messages.step06Description,
      image: createRoute1,
      title: messages.step06,
    },
    {
      id: "routes-creation-2",
      description: messages.step07Description,
      image: createRoute2,
      title: messages.step07,
    },
    {
      id: "routes-creation-3",
      description: messages.step08Description,
      image: createRoute3,
      title: messages.step08,
    },
    {
      id: "routes-editing-1",
      description: messages.step09Description,
      image: editRoute1,
      title: messages.step09,
    },
    {
      id: "routes-editing-2",
      description: messages.step10Description,
      image: editRoute2,
      title: messages.step10,
    },
    {
      id: "routes-editing-3",
      description: messages.step11Description,
      image: editRoute3,
      title: messages.step11,
    },
    {
      id: "planner",
      description: messages.step12Description,
      image: planner,
      title: messages.step12,
    },
  ],
  title: messages.title,
};
